import { reactive, computed } from "vue"
import { defineStore } from "pinia"
import type { Organization } from "@Modules/teams/Data/Models/OrganizationModel"
import { XTeamsStore } from "./XTeamsStore"

export type PiniaState = {
  defaultOrgSlug: string | null,
  teamsAllowed: boolean,
}

/**
 * The XUserTeamStore pinia store is used to provide you with user sepcific team information such as the users
 * default team
 */
export const XUserTeamStore = defineStore("x-user-team", () => {
  const xTeamsStore = XTeamsStore();

  // Data
  const state = reactive<PiniaState>({
    // The default organization for this user. When you click the manage account button, this is where the
    // user should be redirected to
    defaultOrgSlug: null,

    // Whether teams feature is allowed for this user
    // Only Allow for organization owners without personal plan.
    teamsAllowed: false,
  });

  //
  // Getters
  const defaultOrganization = computed<Organization | null>(() => xTeamsStore.getOrganizationBySlug(state.defaultOrgSlug));
  const isTeamsAllowed = computed<boolean>(() => state.teamsAllowed);

  //
  // Actions
  /**
   * The application has a god route called /state that is used to send down basically all information about the
   * application. This route contains the default org and team for this user. Every time this state route 
   * is called, the orgs and teams will be passed to this store using this method.
   */
  const initializeFromState = function (defaultOrgSlug: string | null = null, teamsAllowed: boolean = false) {
    state.defaultOrgSlug = defaultOrgSlug;
    state.teamsAllowed = teamsAllowed;
  }

  return {
    defaultOrganization,
    isTeamsAllowed,
    initializeFromState,
  };
});
